import { render, staticRenderFns } from "./ExcHeaderDropdownItem.vue?vue&type=template&id=56db5182&scoped=true&"
import script from "./ExcHeaderDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ExcHeaderDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ExcHeaderDropdownItem.vue?vue&type=style&index=0&id=56db5182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db5182",
  null
  
)

export default component.exports